<template>
	<div class="single__header">
		<div class="back">
			<a @click="goBack()"><img :src="back_icon" alt="back" /></a>
		</div>
		<div class="inner">
			<h1 v-html="title"></h1>
			<h3 v-html="description"></h3>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		title: {},
		back_icon: {},
		description: {},
	},

	computed: {},

	watch: {},

	methods: {
		goBack() {
			window.history.back();
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.single__header {
	grid-column: 1 / span 12;
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	column-gap: 0;
	position: relative;
	background: #f2f2f2;
	padding: 50px 0 25px;

	.back {
		grid-column: 2 / span 1;

		@media (max-width: 1366px) {
			grid-column: span 0;
			display: none;
		}

		a {
			&:hover {
				cursor: pointer;

				img {
					transform: scale(1.25);
					border-radius: 50%;
					-webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
					box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
				}
			}
		}

		img {
			height: 50px;
			transform: scale(1);
			transition: 0.2s ease all;
			border-radius: 50%;
		}
	}

	.inner {
		grid-column: 3 / span 8;

		@media (max-width: 1366px) {
			grid-column: 2 / span 10;
		}

		h1 {
			color: black;
			font-size: 50px;
			line-height: 45px;
		}

		h3 {
			width: 100%;
			margin-top: 25px;
			line-height: 25px;
		}

		.meta {
			margin-top: 50px;

			#breadcrumbs {
				margin: 0;
				color: #39545f;
				font-size: 0.9rem;

				a {
					color: #39545f;
					font-family: 'Aveny-T PRO', Arial, Helvetica, sans-serif;
					text-decoration: none;
					text-transform: uppercase;
				}

				span {
					color: #39545f;
					font-family: 'Aveny-T PRO', Arial, Helvetica, sans-serif;
					text-transform: uppercase;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SingleHeader.vue